import Icon from '../components/Icon.vue'

Icon.register({
  'kiwi-bird': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M575.8 218c0.3 5.8 0.2 246 0.2 246 0 7.3-5 13.7-12 15.5-1.3 0.3-2.6 0.5-4 0.5-5.8 0-11.2-3.1-14-8.3l-74.4-136.4c-7 0.5 2.4 0.8-23 0.8-54.6 0-106.4 19.3-152.1 49.1-12.5 8.1-26.1 14.5-40.3 19.5v59.4c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-49.2c-5.3 0.4-10.6 1.2-16 1.2-16.6 0-32.6-2.3-48-6.3v54.3c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-74c-57.3-33.2-96-95.1-96-166-0.1-145.8 129.3-182.9 147.3-186.9 57.2-12.9 111.2-0.3 153.2 28.7 43.5 30 94.9 46.2 147.7 46.2h9.4c60.7 0 115 45.4 118.2 106zM464 248c13.3 0 24-10.8 24-24 0-13.3-10.8-24-24-24s-24 10.7-24 24c0 13.3 10.8 24 24 24zM544 401.3v-99.1c-11.1 11.4-24.7 20.1-39.9 26z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/kiwi-bird.js
// module id = 1504
// module chunks = 0